import React from 'react';
import classNames from 'classnames';
/**
 * The ConsumptionGraphic component is a visual representation of energy classes and consumption.
 * It displays {@link EfficiencyTag} in a standardized format.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-consumption-graphic.html
 * @constructor
 */
export function ConsumptionGraphic({ activeRatings, caption, children, className, labels, scope = 'eu', testId, ...otherProps }) {
    const classNameList = classNames('c-consumption-graphic', className).trim();
    function renderIfCaption() {
        if (caption) {
            return React.createElement("figcaption", { className: "c-consumption-graphic__caption u-visually-hidden" }, caption);
        }
        return null;
    }
    function renderIfLabels() {
        if (labels) {
            {
                return labels?.map((label, i) => (React.createElement("span", { className: "c-consumption-graphic__column-label", key: `column-label-${i + 1}` }, label)));
            }
        }
        return null;
    }
    return (React.createElement("figure", { className: classNameList, "data-testid": testId, ...otherProps },
        renderIfCaption(),
        React.createElement("span", { className: "c-consumption-graphic__graphic", "aria-hidden": "true", "data-efficiency-tag-scope": scope },
            React.Children.map(children, (efficiencyTag) => {
                const isActive = activeRatings?.includes(efficiencyTag?.props?.rating);
                const index = activeRatings?.findIndex((item) => item === efficiencyTag?.props?.rating) ?? 0;
                if (!React.isValidElement(efficiencyTag)) {
                    return null;
                }
                if (isActive && (index == 0 || index == 1)) {
                    const column = (index + 1);
                    return (React.createElement(ConsumptionGraphicItem, { column: column },
                        React.cloneElement(efficiencyTag, {
                            scope,
                        }),
                        React.cloneElement(efficiencyTag, {
                            pointer: true,
                            key: `rating-pointer-${column}`,
                        })));
                }
                return (React.createElement(ConsumptionGraphicItem, null, React.cloneElement(efficiencyTag, {
                    scope,
                })));
            }),
            renderIfLabels())));
}
function ConsumptionGraphicItem({ children, className, column, ...otherProps }) {
    const classNameList = classNames('c-consumption-graphic__item', className).trim();
    return (React.createElement("span", { className: classNameList, "data-consumption-graphic-pointer-column": column, ...otherProps }, children));
}
